import IFirebaseHandler from "./IFirebaseHandler";

export default class FirebaseHandler implements IFirebaseHandler {
  constructor() {}

  setBackgroundMessageHandler(): void {
    console.log(`setBackgroundMessageHandler for web`);
  }
  
  registerForPushNotificationListeners(): void {}

  getToken(): Promise<string | null> {
    return new Promise((resolve, reject) => {
      resolve(null);
    });
  }

  requestPermission(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(false);
    });
  }

  createDefaultChannels(): void {}
}
